var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5H6.5V0.5H4.5V2.5ZM8.5 2.5V0.5H10.5V2.5H8.5ZM4.5 10.5V8.5H6.5V10.5H4.5ZM12.5 6.5V4.5H14.5V6.5H12.5ZM12.5 10.5V8.5H14.5V10.5H12.5ZM8.5 10.5V8.5H10.5V10.5H8.5ZM12.5 2.5V0.5H14.5V2.5H12.5ZM6.5 4.5V2.5H8.5V4.5H6.5ZM0.5 16.5V0.5H2.5V2.5H4.5V4.5H2.5V6.5H4.5V8.5H2.5V16.5H0.5ZM10.5 8.5V6.5H12.5V8.5H10.5ZM6.5 8.5V6.5H8.5V8.5H6.5ZM4.5 6.5V4.5H6.5V6.5H4.5ZM8.5 6.5V4.5H10.5V6.5H8.5ZM10.5 4.5V2.5H12.5V4.5H10.5Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.d68c0b2b6403e1db2206dd52b7932e38.svg";
export { ForwardRef as ReactComponent };